import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { exportReportCsv, exportReportXlsx, exportReportPdf } from '../utils/reportExport';

/**
 * Export current report table as CSV, Excel, or PDF.
 * @param {() => { headers: string[], rows: string[][], footer?: string[] | null, pdfTitle?: string, filenameBase?: string, pdfLandscape?: boolean } | null} getData - return null to skip
 */
const ReportExportMenu = ({ disabled, getData, defaultFilenameBase = 'report', buttonLabel = 'Export' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const runExport = (format) => {
    setAnchorEl(null);
    if (disabled) return;
    const data = typeof getData === 'function' ? getData() : null;
    if (!data || !data.headers || !Array.isArray(data.rows)) return;

    const {
      headers,
      rows,
      footer = null,
      pdfTitle = '',
      filenameBase = defaultFilenameBase,
      pdfLandscape = false
    } = data;
    const base = String(filenameBase).replace(/[/\\?%*:|"<>]/g, '-').slice(0, 80);

    if (format === 'csv') {
      exportReportCsv(`${base}.csv`, headers, rows, footer);
    } else if (format === 'xlsx') {
      exportReportXlsx(`${base}.xlsx`, base.slice(0, 31), headers, rows, footer);
    } else if (format === 'pdf') {
      exportReportPdf(`${base}.pdf`, pdfTitle || base, headers, rows, footer, { landscape: pdfLandscape });
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        endIcon={<KeyboardArrowDown />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={disabled}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        {buttonLabel}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <MenuItem dense onClick={() => runExport('csv')}>
          CSV (.csv)
        </MenuItem>
        <MenuItem dense onClick={() => runExport('xlsx')}>
          Excel (.xlsx)
        </MenuItem>
        <MenuItem dense onClick={() => runExport('pdf')}>
          PDF (.pdf)
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportExportMenu;
